import { Stack, Text } from "basis";
import { SvgInline } from "components/SvgInline/SvgInline";
import { ScreenProps } from "./types";

export const Error = ({ errorFooter }: Pick<ScreenProps, "errorFooter">) => (
  <Stack gap="8">
    <SvgInline name="error-dog" width="236" />
    <Text textStyle="heading5" textStyle-sm="heading4">
      Oops, something went wrong
    </Text>
    <Text>
      We've encountered an unexpected problem and are experiencing difficulties
      in processing your request.
    </Text>
    <Text>
      Please try again later or contact Latitude if the problem persists.
    </Text>
    {errorFooter}
  </Stack>
);
